import {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Form, Input, Label} from 'semantic-ui-react';
import './LandSizeRange.scss';
import NumberValidator from '../../lib/NumberValidator';

const conversion = {
  m2: 1,
  ha: 10000,
};

const MAX_DIGITS_M2 = 9;
const MAX_DIGITS_HA = MAX_DIGITS_M2 - Number(conversion.ha).toString().length + 1;
const MAX_DECIMALS = 2;


export default class LandSizeRange extends Component {
  static propTypes = {
    min: PropTypes.any,
    max: PropTypes.any,
    errors: PropTypes.object,
    onMinChange: PropTypes.func.isRequired,
    onMaxChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      units: 'm2',
      min: this.props.min,
      max: this.props.max,
    };
  };

  componentDidUpdate(prevProps) {
    if (this.props.min !== prevProps.min) {
      if (this.props.min && this.state.units === 'ha') {
        this.setState({min: this.toHa(this.props.min)});
      } else {
        this.setState({min: this.props.min});
      }
    }
    if (this.props.max !== prevProps.max) {
      if (this.props.max && this.state.units === 'ha') {
        this.setState({max: this.toHa(this.props.max)});
      } else {
        this.setState({max: this.props.max});
      }
    }
  }

  toHa(m2) {
    if (m2 < 10000) {
      return m2;
    }
    m2 = m2 / conversion.ha;
    let r = m2.toString();
    const i = r.indexOf('.');
    if (i > 0) r = r.substring(0, Math.min(r.length, i + MAX_DECIMALS + 1));
    return Number(r);
  }

  maxDigits = () => (this.state.units === 'ha' ? MAX_DIGITS_HA : MAX_DIGITS_M2);

  isValidNumber = num => num || num === 0;

  onUnitChange = (e, {value}) => {
    const {onMinChange, onMaxChange} = this.props;
    let {min, max, units} = this.state;
    if (units !== value) {
      if (value === 'ha') {
        if (min) {
          min = this.toHa(min);
        }
        if (max) {
          max = this.toHa(max);
        }
      } else {
        if (min) {
          min = min * conversion.ha;
        }
        if (max) {
          max = max * conversion.ha;
        }
      }
      this.setState({units: value, min: min, max: max});
      if (NumberValidator.isValidDecimal(min, this.maxDigits(), MAX_DECIMALS)) {
        onMinChange({}, {value: `${this.isValidNumber(min) ? min * conversion[value] : ''}`, unit: value });
      }

      if (NumberValidator.isValidDecimal(max, this.maxDigits(), MAX_DECIMALS)) {
        onMaxChange({}, {value: `${this.isValidNumber(max) ? max * conversion[value] : ''}`, unit: value});
      }
    }
  };

  onChange = (field) => (e, {value}) => {
    if (!value || NumberValidator.isValidDecimal(value, this.maxDigits(), MAX_DECIMALS)) {
      this.setState({[field]: value}, () => this.handleAdditionalValidation(field));
    }
  };

  handleAdditionalValidation = (field) => {
    const {onMinChange, onMaxChange} = this.props;
    const {min, max, units} = this.state;
    switch (field) {
      case 'min':
        if (!min || NumberValidator.isValidDecimal(min, this.maxDigits(), MAX_DECIMALS)) {
          onMinChange({}, {value: min ? `${Math.round(min * conversion[units])}` : ''});
        }
        break;
      case 'max':
        if (!max || NumberValidator.isValidDecimal(max, this.maxDigits(), MAX_DECIMALS)) {
          onMaxChange({}, {value: max ? `${Math.round(max * conversion[units])}` : ''});
        }
        break;
      default:
        throw new Error(`unexpected field ${field}`);
    }
  };

  render() {
    const {errors} = this.props;
    const {min, max, units} = this.state;
    return (
      <div className="LandSizeRange">
        <div className="row">
          <label>Land size</label>
        </div>
        <div className="row">
          <Form.Field className="land-area min" error={!!errors.landAreaMin}>
            <Input placeholder="min" value={min} onChange={this.onChange('min')}
                   maxLength={this.maxDigits() + MAX_DECIMALS + 1}/>
            {errors.landAreaMin ? <Label basic color="red" pointing>{errors.landAreaMin}</Label> : null}
          </Form.Field>
          <div className="to">to</div>
          <Form.Field className="land-area max" error={!!errors.landAreaMax}>
            <Input placeholder="max" value={max} onChange={this.onChange('max')}
                   maxLength={this.maxDigits() + MAX_DECIMALS + 1}/>
            {errors.landAreaMax ? <Label basic color="red" pointing>{errors.landAreaMax}</Label> : null}
          </Form.Field>
          <Dropdown className="units" value={units} selection onChange={this.onUnitChange} options={[
            {text: 'm²', value: 'm2'},
            {text: 'ha', value: 'ha'},
          ]}/>
        </div>
      </div>
    );
  };
}
